import Layout from '../../components/layout/Layout'
import TransparentCard from '../../components/ui/transparent-card'

const ThoughtCreativeFreedom = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
          Creative Freedom and Visual Language in Prototyping
        </h1>

        <div className="mt-12 flex flex-row gap-8 items-start">
          <div className="w-full md:w-1/4">
            <TransparentCard
              title="Benevolent dictatorship"
              className="h-full w-full"
            />
          </div>
          <div className="w-full md:w-3/4 flex items-center">
            <p className="text-foreground text-lg leading-relaxed">
              A benevolent dictatorship is a government in which an authoritarian leader exercises absolute political power over the state but is perceived to do so with regard for the benefit of the population as a whole. It stands in contrast to the decidedly malevolent stereotype of a dictator, who focuses on their supporters and their own self-interests.
            </p>
          </div>
        </div>

        <div className="w-full rounded-3xl mt-12">
          <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Untitled-2024-11-02-1609-j3hhul7b0rico47KPUUID2IKAeCEH7.png"
            alt="Portfolio website wireframe showing designer introduction, portfolio showreel, and features section"
            className="w-full h-auto"
          />
          <p className="mt-6 text-foreground text-lg leading-relaxed">
            Creative freedom and visual language are essential in the prototyping phase because they allow for unfiltered expression of ideas, bridging the gap between abstract thoughts and tangible forms. Creative freedom fosters innovation by removing constraints, enabling experimentation and exploration of unconventional solutions. Visual language, on the other hand, provides a medium to communicate complex ideas effectively, transcending the limitations of words. Together, they transform vague mental concepts into clear, shareable prototypes, fostering collaboration and ensuring that the essence of an idea is accurately captured and understood before further refinement.
          </p>
        </div>
      </div>
    </Layout>
  )
}

export default ThoughtCreativeFreedom 